import classNames from 'classnames'

import { useDate } from '../../../hooks'
import { GretaAIChatMessage } from '../GretaAIChatMessage'

import {
  getGretaAIChatLastAssistantTurnIndex,
  getGretaAIChatLastUserTurnIndex,
} from './GretaAIChatMessageListTurns.utils'

import * as styles from './GretaAIChatMessageListTurns.module.css'

function GretaAIChatMessageListTurns({
  anchorRef,
  feedbackByMessageId,
  isLimitReached = false,
  turns,
  onRetry,
  onSubmitFeedback,
}) {
  const now = useDate()

  const lastUserTurnIndex = getGretaAIChatLastUserTurnIndex(turns)
  const lastAssistantTurnIndex = getGretaAIChatLastAssistantTurnIndex(turns)

  return turns.map((message, index) => {
    const previous = turns[index - 1]

    const spacingClassName = classNames({
      [styles.groupGap]: previous && previous.role === message.role,
      [styles.turnGap]: previous && previous.role !== message.role,
    })

    return (
      <GretaAIChatMessage
        canRetry={message.canRetry}
        createdAt={message.createdAt}
        feedback={feedbackByMessageId[message.id]}
        id={message.id}
        isLatestAssistant={index === lastAssistantTurnIndex}
        isLimitReached={isLimitReached}
        isPendingId={message.isPendingId}
        key={message.id}
        now={now}
        ref={index === lastUserTurnIndex ? anchorRef : undefined}
        role={message.role}
        spacingClassName={spacingClassName}
        text={message.text}
        onRetry={onRetry}
        onSubmitFeedback={onSubmitFeedback}
      />
    )
  })
}

export default GretaAIChatMessageListTurns
